import React from 'react';
import PortalContainer from './PortalContainer';
import PortalMenuTemplate from './PortalMenuTemplate';

/**
 * Refactored Portal Menu Component
 * Now uses the container/template pattern for separation of concerns
 */
const portalMenu = () => {
  return (
    <PortalContainer>
      {(portalData) => (
        <PortalMenuTemplate
          categories={portalData.categories}
          profile={portalData.profile}
          showError={portalData.showError}
          isLoading={portalData.isLoading}
          focusIndex={portalData.focusIndex}
          onItemClick={portalData.onItemClick}
        />
      )}
    </PortalContainer>
  );
};

export default portalMenu;
